"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _threePartyConfiguration = require("@/api/appBasicSetup/threePartyConfiguration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  props: {
    jguangBaseConfig: {
      type: Object,
      default: null
    },
    // 激活的渠道 1：极光（默认） 2：袤博
    activMode: {
      type: [Number, String],
      default: 1
    }
  },
  data: function data() {
    return {
      // 极光：appKey / masterSecret；袤博：mobAppKey / mobMasterSecret
      // 推送开关不在当前界面展示，但保留在提交数据中，避免保存时被覆盖丢失
      ruleForm: {
        appKey: '',
        masterSecret: '',
        mobAppKey: '',
        mobMasterSecret: '',
        activMode: 1,
        androidPushStatus: 1,
        iosPushStatus: 1,
        harmonyPushStatus: 1
      },
      rules: {
        appKey: [{
          required: true,
          message: '请输入App Key',
          trigger: 'blur'
        }],
        masterSecret: [{
          required: true,
          message: '请输入Master Secret',
          trigger: 'blur'
        }],
        mobAppKey: [{
          required: true,
          message: '请输入mob AppKey',
          trigger: 'blur'
        }],
        mobMasterSecret: [{
          required: true,
          message: '请输入mob MasterSecret',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    isMob: function isMob() {
      return Number(this.activMode) === 2;
    },
    channelName: function channelName() {
      return this.isMob ? '袤博(Mob Tech)' : '极光推送';
    },
    // 当前渠道对应的字段
    fieldKeys: function fieldKeys() {
      return this.isMob ? {
        appKey: 'mobAppKey',
        secret: 'mobMasterSecret'
      } : {
        appKey: 'appKey',
        secret: 'masterSecret'
      };
    }
  },
  watch: {
    jguangBaseConfig: {
      handler: function handler(val) {
        this.ruleForm = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.ruleForm), val);
      },
      immediate: true,
      deep: true
    },
    // 切换渠道后清除校验提示
    activMode: function activMode() {
      var _this = this;
      this.$nextTick(function () {
        _this.$refs.ruleForm1 && _this.$refs.ruleForm1.clearValidate();
      });
    }
  },
  created: function created() {},
  methods: {
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.$confirm('是否确认修改此配置?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            (0, _threePartyConfiguration.thirdConfig)({
              type: 1,
              jigangConfig: {
                type: 0,
                jguangBaseConfig: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this2.ruleForm), {}, {
                  activMode: _this2.activMode
                })
              }
            }).then(function (res) {
              _this2.$notify.success({
                title: '温馨提示',
                message: '保存成功！'
              });
              // 保存成功后重新查询最新配置（/portal/system/tenant/queryThirdConfig）
              (0, _threePartyConfiguration.queryThirdConfig)({
                type: 1
              }).then(function (qres) {
                var cfg = qres.data && qres.data.jigangConfig && qres.data.jigangConfig.jguangBaseConfig;
                if (cfg) {
                  _this2.ruleForm = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this2.ruleForm), cfg);
                }
              });
            });
          });
        } else {
          return false;
        }
      });
    },
    jumpTutorial: function jumpTutorial() {
      window.open('https://www.yuque.com/weixu-spa2e/pe5gxx/sq0mrgyzm1z2z7u2');
    }
  }
};